export default {
  // getAllApiResources
  GET_ALL_API_RESOURCES_SUCCESS: 'GET_ALL_API_RESOURCES_SUCCESS',
  // getAllApplicationCategories
  GET_ALL_APPLICATION_CATEGORIES_SUCCESS: 'GET_ALL_APPLICATION_CATEGORIES_SUCCESS',
  // getProductPropertyFormats
  START_GET_PRODUCT_PROPERTY_FORMATS: 'START_GET_PRODUCT_PROPERTY_FORMATS',
  GET_PRODUCT_PROPERTY_FORMATS_SUCCESS: 'GET_PRODUCT_PROPERTY_FORMATS_SUCCESS',
  GET_PRODUCT_PROPERTY_FORMATS_FAILED: 'GET_PRODUCT_PROPERTY_FORMATS_FAILED',
  // getAllPlatforms
  GET_ALL_PLATFORMS_SUCCESS: 'GET_ALL_PLATFORMS_SUCCESS'
};
